<template>

    <Path>
        <template v-slot:path>
            <li><router-link :to="{name: 'dashboard'}" >الصفحة الرئيسية</router-link> </li>
            <li> <span class="divider"> / </span><a href="#services" @click="$router.push({name: 'dashboard'})">الخدمات </a> </li> 
            <li> <span class="divider"> / </span><router-link :to="{name:'electronicservices'}" >الخدمات الالكترونية</router-link> </li> 
            <li> <span class="divider"> / </span><a href="#">{{docPath}} </a> </li>        
        </template>
    </Path>

    <section id="content">
        <div class="py-4 grayBG">
            <div class="container">
                <div class="row">
                    <div class="col-12 mb-2">
                        <h2 class="blueFont ">{{docName}}</h2>
                    </div>
                    <div class="col-md-3">
                        <p class="text-danger fw-bold"> <i class="bi bi-clock fw-bold"></i> مدة إتمام الخدمة</p>
                        <p>7 أيام عمل</p>
                    </div>
                    <div class="col-md-3">
    
                        <p class="text-danger fw-bold"> <i class=" fw-bold">ج.م</i> رسوم الخدمة</p>
                        <p>{{servicePrice}} جنيهاً مصرياً</p>
                    </div>
                    <div class="col-md-6">
                        <div class="d-flex justify-content-md-end justify-content-center">
                            <button type="button" @click="ToDoc()" :disabled="!accepted" class="btn btn-primary">بدء الخدمة  <i class="bi bi-arrow-left-circle float-start "></i></button>
                        </div>
                    </div>
    
                </div>
            </div>
        </div>
    </section>

    <section>
        <div class="py-5 ">
            <div class="container">
                <div class="row">
                    <div class="col-12 my-2">
                        <h3>عن الخدمة</h3>
                        <p>تتيح  هذه الخدمة استخراج {{docName}} لمقدم الطلب او لشخص اخر فى حدود الشروط والقوانين</p>
                    </div>
                    <div class="col-12 my-2">
                        <h3> شروط الخدمة</h3>
                        <ul class="numbers_list">
                            <div v-html="regulation_lookups"></div>
                        </ul>
                    </div>
                    <div class="col-12 my-2">
                        <h3>المستندات المطلوبة</h3>
                        <p>لا يوجد مستندات مطلوبة</p>
                        <div class="form-check my_Form">
                            <label class="form-check-label blueFont fw-bold" for="flexCheckDefault">
                                موافق/ة على الشروط و الأحكام
                            </label>
                            <input v-model="accepted"  class="form-check-input" type="checkbox" value="" id="flexCheckDefault">                    
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import sharedMethods from "@/shared/sharedMethods";
import sharedData from '@/shared/sharedData';
import Path from "@/components/Path.vue";

export default {
    ... sharedMethods,
   name: 'RegulationsView',
   components:{Path},
   data(){
    return{
        accepted: false,
        regulation_lookups: [],
        document_lookups: [],
        servicePrice:''
    }
   },
   created(){
        setTimeout(() => {
                this.getServicePrice();
                sharedMethods.getRegulations(this.docCode).then(res=>{this.regulation_lookups = res;});
            }, 200);    
    },

    watch: {
        accepted(newValue) {
        if (newValue) {
            window.scrollTo({ top: 0, behavior: "smooth" });
        }
        },
    },

   computed:{
    docName(){
        return this.$route.params.docType==='birthfirsttime'? "وثيقة ميلاد اول مرة" :
               this.$route.params.docType==='birth'? "وثيقة ميلاد" :
               this.$route.params.docType==='death'?  "قيد وفاة" :
               this.$route.params.docType==='marriage'? "وثيقة زواج" :
               this.$route.params.docType==='divorce'? "وثيقة طلاق" :
               this.$route.params.docType==='nid'? "بطاقة رقم قومى بدل فاقد/تالف" :
               this.$route.params.docType==='nidform'? "استمارة رقم قومي مميكنة" :
               this.$route.params.docType==='personalrecord'? "قيد فردى":
               this.$route.params.docType==='familyrecord'? "قيد عائلى":  ""
    },
    docCode(){
        return this.$route.params.docType==='birthfirsttime'? sharedData.DocumentsCode.BirthFirstTimeCode :
               this.$route.params.docType==='birth'? sharedData.DocumentsCode.BirthCode :
               this.$route.params.docType==='death'?  sharedData.DocumentsCode.DeathCode:
               this.$route.params.docType==='marriage'? sharedData.DocumentsCode.MarriageCode :
               this.$route.params.docType==='divorce'? sharedData.DocumentsCode.DivorceCode:
               this.$route.params.docType==='nid'? sharedData.DocumentsCode.NidCode :
               this.$route.params.docType==='nidform'? sharedData.DocumentsCode.NormalNidFormCode :
               this.$route.params.docType==='personalrecord'? sharedData.DocumentsCode.PersonalRecordCode:
               this.$route.params.docType==='familyrecord'? sharedData.DocumentsCode.FamilyRecordCode: ""
    },
    docPath(){
        return this.$route.params.docType==='birth'? "استخراج شهادة ميلاد" :
               this.$route.params.docType==='birthfirsttime'? "استخراج شهادة ميلادأول مرة" :
               this.$route.params.docType==='death'? "استخراج قيد وفاه" :
               this.$route.params.docType==='marriage'? "استخراج قسيمة زواج" :
               this.$route.params.docType==='divorce'? "استخراج قسيمة طلاق" :
               this.$route.params.docType==='nid'? "استخراج بطاقة الرقم القومى" : 
               this.$route.params.docType==='nidform'? "شراء استمارة رقم قومي مميكنة" :
               this.$route.params.docType==='personalrecord'? "استخراج قيد فردى":
               this.$route.params.docType==='familyrecord'? "استخراج قيد عائلى": ""
    },

   },
   methods:{
    ToDoc(){
        if(this.$route.params.docType==='birthfirsttime'){this.$router.push({name:'birthFirstTimeRequest' }); this.docPath="استخراج شهادة ميلادأول مرة";}
        if(this.$route.params.docType==='birth'){this.$router.push({name:'birthRequest' }); this.docPath="استخراج شهادة ميلاد";}
        if(this.$route.params.docType==='death'){this.$router.push({name:'deathRequest'}); this.docPath="استخراج قيد وفاه";}
        if(this.$route.params.docType==='marriage'){this.$router.push({name:'marriageRequest' }); this.docPath="استخراج قسيمة زواج";}
        if(this.$route.params.docType==='divorce'){this.$router.push({name:'divorceRequest' }); this.docPath="استخراج قسيمة طلاق";}
        if(this.$route.params.docType==='nid'){this.$router.push({name:'nidRequest' }); this.docPath="استخراج بطاقة الرقم القومى";}
        if(this.$route.params.docType==='nidform'){this.$router.push({name:'nidform' }); this.docPath="شراء استمارة رقم قومي مميكنة" ;}
        if(this.$route.params.docType==='personalrecord'){this.$router.push({name:'personalrecord' }); this.docPath="استخراج قيد فردى";}
        if(this.$route.params.docType==='familyrecord'){this.$router.push({name:'familyrecord' }); this.docPath="استخراج قيد عائلى";}
    },

    async getServicePrice(){
        if(this.$route.params.docType==='birth'){
            await sharedMethods.get_servicePrice("birthPrice").then(res=>{this.servicePrice = res;});
        }

        if(this.$route.params.docType==='birthfirsttime'){
            await sharedMethods.get_servicePrice("birthFirstTimeRecordPrice").then(res=>{this.servicePrice = res;});
        }

        if(this.$route.params.docType==='death'){
            await sharedMethods.get_servicePrice("deathPrice").then(res=>{this.servicePrice = res;});
        }
        if(this.$route.params.docType==='marriage'){
            await sharedMethods.get_servicePrice("marriagePrice").then(res=>{this.servicePrice = res;});
        }
        if(this.$route.params.docType==='divorce'){
            await sharedMethods.get_servicePrice("divorcePrice").then(res=>{this.servicePrice = res;});
        }
        if(this.$route.params.docType==='nid'){
            await sharedMethods.get_servicePrice("nidPrice").then(res=>{this.servicePrice = res;});
        }
        if(this.$route.params.docType==='nidform'){
            await sharedMethods.get_servicePrice("nidFormPrice").then(res=>{this.servicePrice = res;});
        }
        if(this.$route.params.docType==='familyrecord'){
            await sharedMethods.get_servicePrice("familyRecordPrice").then(res=>{this.servicePrice = res;});
        }

        if(this.$route.params.docType==='personalrecord'){
            await sharedMethods.get_servicePrice("personalRecordPrice").then(res=>{this.servicePrice = res;});
        }
    },
  }
  }
</script>